// Shopify caps `paginate by` below the value the theme requests, so large
// collections (e.g. Madelinetosh, 500+ colors) get split across multiple
// pages. Pagination preserves the collection's natural order, but the
// theme's per-page liquid sort only orders products inside each page —
// not across pages. After a naive AJAX merge, page 1 holds colors A–G,
// page 2 holds H–O, etc., chunked.
//
// This script:
//   1. Fetches the remaining pages via the Section Rendering API.
//   2. Combines page-1 (already in the DOM) with the fetched products and
//      sorts the whole set ONCE by `color`, off-DOM, before injecting.
//   3. Reinserts everything in a single DocumentFragment swap so the
//      browser performs one layout instead of one per node.
//
// Sorting after the merge (when the user clicks a sort button) is left to
// the existing handler in application.js — this script does not bind any
// click listeners, so there are no races with that handler.
(function () {
  var SOURCE = 'collection-merge-pages';
  var collator = new Intl.Collator('en', { sensitivity: 'base' });

  function log() {
    if (window.__COLLECTION_MERGE_DEBUG__) {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[' + SOURCE + ']');
      // eslint-disable-next-line no-console
      console.log.apply(console, args);
    }
  }

  function buildSectionUrl(page, sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', page);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function fetchPage(page, sectionId) {
    return fetch(buildSectionUrl(page, sectionId), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) { return html ? { page: page, html: html } : null; })
      .catch(function () { return null; });
  }

  function collectFromResults(results) {
    var items = [];
    var sorted = results.filter(Boolean).sort(function (a, b) {
      return a.page - b.page;
    });

    for (var i = 0; i < sorted.length; i++) {
      var doc = new DOMParser().parseFromString(sorted[i].html, 'text/html');
      var nodes = doc.querySelectorAll(
        '[data-collection-product-list] > [sortable]'
      );
      for (var n = 0; n < nodes.length; n++) {
        items.push(nodes[n]);
      }
    }
    return items;
  }

  function sortByColor(items) {
    items.sort(function (a, b) {
      var x = a.getAttribute('color') || '';
      var y = b.getAttribute('color') || '';
      return collator.compare(x, y);
    });
  }

  function replaceContainerChildren(container, items) {
    // Detach the container so all DOM moves below happen offline. A
    // disconnected subtree triggers no layout/style work, so adding
    // hundreds of children only costs one layout when we reattach.
    var parent = container.parentNode;
    if (!parent) return;

    var placeholder = document.createComment('cmp-anchor');
    parent.replaceChild(placeholder, container);

    try {
      // Empty the container first.
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
      // Append all items in order.
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < items.length; i++) {
        fragment.appendChild(items[i]);
      }
      container.appendChild(fragment);
    } finally {
      parent.replaceChild(container, placeholder);
    }
  }

  function init() {
    var container = document.querySelector('[data-collection-product-list]');
    if (!container) return;

    var currentPage =
      parseInt(container.getAttribute('data-current-page'), 10) || 1;
    var totalPages =
      parseInt(container.getAttribute('data-total-pages'), 10) || 1;
    var sectionId = container.getAttribute('data-section-id') || '';

    log('init', {
      currentPage: currentPage,
      totalPages: totalPages,
      sectionId: sectionId
    });

    if (totalPages <= 1) return;

    var pagination = document.querySelector('.collection-pagination');
    if (pagination) pagination.style.display = 'none';

    var loader = document.querySelector('.collection-pagination-loader');

    var requests = [];
    for (var p = 1; p <= totalPages; p++) {
      if (p !== currentPage) requests.push(fetchPage(p, sectionId));
    }

    Promise.all(requests).then(function (results) {
      var t0 = performance.now();

      var existing = Array.prototype.slice.call(
        container.querySelectorAll('[sortable]')
      );
      var fromAjax = collectFromResults(results);
      var all = existing.concat(fromAjax);

      sortByColor(all);
      replaceContainerChildren(container, all);

      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }

      log(
        'merged + sorted',
        all.length,
        'products in',
        (performance.now() - t0).toFixed(1),
        'ms'
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
